module.exports = __webpack_public_path__ + "assets/img/heat-diy.f370dbaa.jpg";